type KanbanFetchGenerationState = {
  __KANBAN_FETCH_GENERATION__?: Record<string, number>;
  __KANBAN_LOADED_QUERY_KEYS__?: Record<string, string>;
  __KANBAN_INFLIGHT_QUERY_KEYS__?: Record<string, string>;
};

const globalState = (): KanbanFetchGenerationState =>
  globalThis as KanbanFetchGenerationState;

export const buildKanbanQuerySignature = (input: {
  filtersKey: string;
  sortKey: string;
  parentScopeKey: string;
  layoutKey: string;
  baseQueryKey: string;
}): string =>
  [
    input.filtersKey,
    input.sortKey,
    input.parentScopeKey,
    input.layoutKey,
    input.baseQueryKey,
  ].join("|");

export const nextKanbanFetchGeneration = (blockId: string): number => {
  const state = globalState();
  if (!state.__KANBAN_FETCH_GENERATION__) {
    state.__KANBAN_FETCH_GENERATION__ = {};
  }
  const next = (state.__KANBAN_FETCH_GENERATION__[blockId] ?? 0) + 1;
  state.__KANBAN_FETCH_GENERATION__[blockId] = next;
  return next;
};

export const getLatestKanbanFetchGeneration = (blockId: string): number =>
  globalState().__KANBAN_FETCH_GENERATION__?.[blockId] ?? 0;

export const getLoadedKanbanQuerySignature = (blockId: string): string | undefined =>
  globalState().__KANBAN_LOADED_QUERY_KEYS__?.[blockId];

export const markKanbanQueryLoaded = (
  blockId: string,
  queryKey: string,
): void => {
  const state = globalState();
  if (!state.__KANBAN_LOADED_QUERY_KEYS__) {
    state.__KANBAN_LOADED_QUERY_KEYS__ = {};
  }
  state.__KANBAN_LOADED_QUERY_KEYS__[blockId] = queryKey;
};

export const getInflightKanbanQuerySignature = (
  blockId: string,
): string | undefined => globalState().__KANBAN_INFLIGHT_QUERY_KEYS__?.[blockId];

export const setInflightKanbanQuerySignature = (
  blockId: string,
  queryKey: string | undefined,
): void => {
  const state = globalState();
  if (!state.__KANBAN_INFLIGHT_QUERY_KEYS__) {
    state.__KANBAN_INFLIGHT_QUERY_KEYS__ = {};
  }
  if (queryKey === undefined) {
    delete state.__KANBAN_INFLIGHT_QUERY_KEYS__[blockId];
    return;
  }
  state.__KANBAN_INFLIGHT_QUERY_KEYS__[blockId] = queryKey;
};

export const clearKanbanQuerySignatures = (blockId: string): void => {
  const state = globalState();
  delete state.__KANBAN_LOADED_QUERY_KEYS__?.[blockId];
  delete state.__KANBAN_INFLIGHT_QUERY_KEYS__?.[blockId];
};
